import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Live height (px) of an element, kept current by a ResizeObserver. Returns [ref, height];
 * height is 0 while the element is absent or empty. Used to leave scroll room under an overlay.
 */
export default function useElementHeight() {
  const [height, setHeight] = useState(0);
  const observer = useRef(null);
  const ref = useCallback((el) => {
    observer.current?.disconnect();
    observer.current = null;
    if (!el) { setHeight(0); return; }
    const read = () => setHeight(Math.round(el.getBoundingClientRect().height));
    read();
    if (typeof ResizeObserver === 'undefined') return;
    observer.current = new ResizeObserver(read);
    observer.current.observe(el);
  }, []);
  useEffect(() => () => observer.current?.disconnect(), []);
  return [ref, height];
}
